import React, { useState } from 'react';
import useCollapse from 'react-collapsed';
import { faChevronDown, faChevronRight, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Product from './Product';

export default function Deal(props) {
    const { getCollapseProps } = useCollapse({ isOpen: props.isOpen });

    const deal = props.deal;
    const [message, setMessage] = useState(props.deal.message);

    function toggleCollapse() {
        props.setExpandedState({ ...props.expandedDeals, [deal.id]: !props.isOpen });
    }

    function dealContainsErrors() {
        if (deal.status === 'INVALID') {
            return (
                <span data-testid={'presell-retail-deal-invalid-alert'}>
                    <FontAwesomeIcon className={'icon-error'} icon={faExclamationTriangle} />
                    &nbsp;
                </span>
            );
        }

        if (deal.status === 'UNKNOWN') {
            return (
                <span data-testid={'presell-retail-deal-unknown-alert'}>
                    <FontAwesomeIcon className={'icon-warning'} icon={faExclamationTriangle} />
                </span>
            );
        }
    }

    function updateQuantities(data) {
        deal.status = data.status;
        setMessage(data.message);
        props.updateQuantities(data);
    }

    return (
        <tr id={'presell-deal-' + deal.id}>
            <td className={'presell-deal-table-cell'}>
                <div
                    data-testid={'deal-summary-section'}
                    className={'deal-summary-section'}
                    onClick={toggleCollapse}
                >
                    <table>
                        <tbody>
                            <tr>
                                <td width="5%">
                                    <h5>
                                        {props.isOpen ? (
                                            <FontAwesomeIcon icon={faChevronDown} />
                                        ) : (
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        )}
                                    </h5>
                                </td>
                                <td data-testid={'presell-retail-deal-error-alert'} width="5%">
                                    <h4>{dealContainsErrors()}</h4>
                                </td>
                                <td data-testid={'presell-retail-deal-name'} width="35%">
                                    <h6>{deal.name}</h6>
                                    <h6 data-testid={'presell-retail-deal-message'}> {message}</h6>
                                </td>
                                <td
                                    data-testid={'presell-retail-deal-short-desc'}
                                    style={{ textAlign: 'left' }}
                                    width="40%"
                                >
                                    <h6>{deal.shortDescription}</h6>
                                </td>
                                <td
                                    data-testid={'presell-retail-deal-maxRedeemable'}
                                    style={{ textAlign: 'right' }}
                                    width="15%"
                                >
                                    {!!deal.maxRedeemable && <h6>Max Redeemable: {deal.maxRedeemable}</h6>}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {props.isOpen && (
                    <div
                        data-testid={'deal-product-section'}
                        className={'deal-product-section'}
                        {...getCollapseProps()}
                    >
                        <div className={'deal-long-description'}>{deal.longDescription}</div>
                        <table
                            data-testid={'presell-retail-product-table'}
                            className={'presell-retail-product-table'}
                        >
                            <thead>
                                <tr>
                                    <th className={'image-column'}>Image</th>
                                    <th>Code</th>
                                    <th className={'presell-product-description'}>Description</th>
                                    <th>Unit Size</th>
                                    <th>Normal Cost</th>
                                    <th>Deal Cost</th>
                                    <th>Normal RSP</th>
                                    <th>Deal RSP</th>
                                    <th>Margin</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.deal.regularProducts.map((product, index) => (
                                    <Product
                                        reward={false}
                                        product={product}
                                        key={index}
                                        updateQuantities={updateQuantities}
                                        orderingTimeFinished={props.orderingTimeFinished}
                                        highlighted={
                                            !!props.highlightedProducts &&
                                            props.highlightedProducts[product.id]
                                        }
                                    />
                                ))}
                                {props.deal.rewardProducts.map((product, index) => (
                                    <Product
                                        reward={true}
                                        product={product}
                                        key={index}
                                        updateQuantities={updateQuantities}
                                        orderingTimeFinished={props.orderingTimeFinished}
                                        highlighted={
                                            !!props.highlightedProducts &&
                                            props.highlightedProducts[product.id]
                                        }
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </td>
        </tr>
    );
}
